// Mueve el contenido de "Recompensas del carrito" (sections/cart-drawer-rewards.liquid
// — la zona de bloques de app del carrito, ej. canje de puntos LoyaliU) desde
// el portal escondido en layout/theme.liquid hasta su lugar real dentro del
// cart drawer.
//
// Por qué existe este portal en vez de renderizar la sección directo en el
// drawer: {% section %} no se renderiza (ni el wrapper vacío) si queda
// anidado dentro de un snippet — probado en local, cart-drawer.liquid es un
// snippet — así que la sección se declara a nivel de layout (contexto
// soportado) y este script la traslada visualmente al lugar correcto.
//
// Por qué re-ejecuta el <script> a mano: el carrito se refresca
// reemplazando el innerHTML de .cart-drawer__inner completo (ver
// cart-shipping-estimate.js) — eso destruye cualquier nodo que hayamos
// insertado ahí antes. Copiamos el HTML del portal (que nunca se toca, vive
// afuera del drawer) cada vez que el drawer se refresca. El bloque de
// LoyaliU se auto-inicializa con `document.currentScript.previousElementSibling`
// — un patrón pensado para HTML+script recién insertados juntos — pero los
// navegadores no ejecutan <script> insertados vía innerHTML por spec, así
// que hay que recrear cada <script> a mano (createElement + replaceWith) para
// que corra de verdad.
(function () {
  function executeScripts(container) {
    container.querySelectorAll('script').forEach(function (oldScript) {
      var newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach(function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }

  function placeRewards() {
    var portal = document.getElementById('cart-drawer-rewards-portal');
    var target = document.querySelector('[data-cart-drawer-rewards-target]');
    if (!portal || !target || target.dataset.filled === 'true') return;

    var html = portal.innerHTML.trim();
    if (!html) return; // sin bloques agregados todavía (o app desactivada)

    target.innerHTML = html;
    target.dataset.filled = 'true';
    executeScripts(target);
  }

  document.addEventListener('DOMContentLoaded', function () {
    placeRewards();

    var inner = document.querySelector('.cart-drawer__inner');
    if (inner) {
      new MutationObserver(placeRewards).observe(inner, { childList: true });
    }
  });
})();
